/**
 * API Configuration Constants
 * ------------------------------------------------------------
 * Centralized configuration for API endpoints and base URLs.
 * Helps maintain consistency and simplifies updates across the app.
 */

/** Base API URL (loaded from environment variables) */
export const BASE_URL = import.meta.env.VITE_APP_BASE_API_URL;

/** API versioning */
export const VERS = "v1";

/** Service names for constructing endpoints */
const SERVICES = {
  USER: "user",
  ADMIN: "admin",
};

/** Base path for user authentication routes */
const USER_AUTH = `api/${VERS}/users`;

const ADMIN = `api/${VERS}`;
// const TENANT = `api/${VERS}/tenants`;
// const CAMPAIGN = `api/${VERS}/campaigns`;
// const EXPERIENCES = `api/${VERS}/experiences`;
// const USER = `api/${VERS}/users`;

/**
 * EndpointSlug
 * ------------------------------------------------------------
 * Centralized endpoint paths for user-related API calls.
 * Usage: `${BASE_URL}/${EndpointSlug.USER_AUTH}`
 */
export const EndpointSlug = {
  // ---------------- Admin Authentication Endpoints ----------------
  /** Admin login endpoint */
  USER_AUTH: `${ADMIN}/auth/${SERVICES?.ADMIN}/login`,
  // USER_AUTH: `${SERVICES?.ADMIN}/auth/login`,

  /** Admin change password endpoint */
  USER_CHANGE_PASSWORD: `${ADMIN}/auth/${SERVICES?.ADMIN}/change-password`,

  /** Admin forgot password endpoint */
  USER_FORGOT_PASSWORD: `${ADMIN}/${SERVICES?.ADMIN}/auth/forgot-password`,

  /** Admin reset password endpoint */
  USER_RESET_PASSWORD: `${ADMIN}/${SERVICES?.ADMIN}/auth/reset-password`,
  /** User Get-Presigned_URL endpoint */
  GET_PRESIGNED_URL: `${ADMIN}/tenants`,

  /** User GetCAMPAIGN endpoint */
  GET_CAMPAIGN: `${ADMIN}/campaigns`,
  GET_CAMPAIGN_BY_TENANTID:`${ADMIN}/campaigns/tenant`,

  CREATE_CAMPAIGN: `${ADMIN}/campaigns`,
  UPDATE_CAMPAIGN: `${ADMIN}/campaigns`,

  GET_EXPERIENCES: `${ADMIN}/experiences`,
  CREATE_EXPERIENCE: `${ADMIN}/experiences`,
  UPDATE_EXPERIENCE: `${ADMIN}/experiences`,
  PUBLISH_EXPERIENCES:`${ADMIN}/experiences`,

  GET_SIMULATION_TEMPLATES: `${ADMIN}/simulation-templates`,

  /** Create tenant */
  CREATE_TENANT: `${ADMIN}/tenants`,

  /** Get tenant*/
  GET_TENANT: `${ADMIN}/tenants`,

  /** Get tenant by Id*/
  GET_TENANT_BY_ID: `${ADMIN}/tenants`,

  /** Deactivate tenant by Id*/
  DEACTIVATE_TENANT_BY_ID: `${ADMIN}/tenants`,

  /** Deactivate tenant by Id*/
  FORGOT_PASSWORD: `${ADMIN}/auth/admin/request-password-reset`,

  /** Update tenant by Id*/
  UPDATE_TENANT: `${ADMIN}/tenants`,

  /** Update branding by Id*/
  UPDATE_TENANT_BRANDING: `${ADMIN}/tenants`,

  GET_SIMULATION_CONFIGURATIONS: `${ADMIN}/simulation-configurations`,

  GET_EXPERIENCE_USERS: `${ADMIN}/experiences`,

  CREATE_SIMULATION_CONFIGURATIONS: `${ADMIN}/simulation-configurations`,
  
  PUBLISH_SIMULATION_CONFIGURATIONS: `${ADMIN}/simulation-configurations`,

  UPDATE_SIMULATION_CONFIGURATIONS: `${ADMIN}/simulation-configurations`,

  GET_EXPERIENCES_BY_CAMPAIGN:`${ADMIN}/experiences`,

  /** Overall Analytics*/
  OVERALL_ANALYTICS: `${ADMIN}/analytics/overall`,

  /** Tenant Analytics*/
  TENANT_ANALYTICS: `${ADMIN}/analytics/tenant`,

  /** Experience Participation*/
  Experience_Participation: `${ADMIN}/analytics/experience`,

   /** Experience Participation*/
  TENANT_CAMPAIGNS: `${ADMIN}/campaigns/tenant`,

  SIMULATION_CONFIGURATIONS_ASSETS_PRESIGN:`${ADMIN}/simulation-configurations/assets/presign`,

  GET_APPLICATION_ONBOARDING:`${ADMIN}/application-onboardings`,

  GET_APPLICATION_ONBOARDING_BY_ID:`${ADMIN}/application-onboardings`,

  CREATE_APPLICATION_ONBOARDING:`${ADMIN}/application-onboardings`,

  UPDATE_APPLICATION_ONBOARDING:`${ADMIN}/application-onboardings`,

  
};
